import React from "react";
import { API } from "../context/AuthContext";

/**
 * Official MonRépétiteur logo — uses the brand PNG served from the backend.
 *
 * Props:
 *  - size: number — height of the icon in px (default 40). Wordmark scales accordingly.
 *  - wordmark: bool — whether to render the brand name next to the icon (default true).
 *  - className: extra Tailwind / CSS classes.
 *  - inverted: bool — render the wordmark in white (for dark backgrounds).
 *  - iconOnly: alias of !wordmark, kept for readability.
 */
export default function Logo({
  size = 40,
  wordmark = true,
  className = "",
  inverted = false,
  iconOnly = false,
}) {
  const showWordmark = wordmark && !iconOnly;
  const wordmarkSize = Math.round(size * 0.62);

  return (
    <span
      className={`inline-flex items-center gap-2.5 ${className}`}
      data-testid="brand-logo"
    >
      <img
        src={`${API}/static/illustrations/brand_logo.png`}
        alt="MonRépétiteur"
        width={size}
        height={size}
        style={{ height: size, width: "auto", objectFit: "contain", display: "block" }}
        draggable={false}
      />
      {showWordmark && (
        <span
          className="font-display font-bold tracking-tight"
          style={{
            fontSize: `${wordmarkSize}px`,
            lineHeight: 1,
            color: inverted ? "#FFFFFF" : "#0A422D",
            letterSpacing: "-0.5px",
          }}
        >
          <span style={{ color: "#16A34A" }}>Mon</span>
          <span style={{ color: inverted ? "#FFFFFF" : "#0A422D" }}>Répétiteur</span>
        </span>
      )}
    </span>
  );
}
